<div class="container mt-4 student-list-shell">
  <div class="student-list-toolbar">
    <div class="student-list-heading">
      <h4 class="student-list-title">
        <i class="fa" [ngClass]="iIsArchived ? 'fa-archive' : 'fa-users'" aria-hidden="true"></i>
        {{ iIsArchived ? 'Élèves archivés' : 'Élèves' }}
      </h4>
      <div class="student-list-counters">
        <span class="student-list-count" *ngIf="iPageStudent">
          {{ iPageStudent.totalElements }} élève{{ iPageStudent.totalElements > 1 ? 's' : '' }}{{ onlyToCreate ? ' à créer' : '' }}
        </span>
        <button type="button" class="student-to-create-chip" *ngIf="toCreateCount > 0 || onlyToCreate"
                [class.active]="onlyToCreate" [attr.aria-pressed]="onlyToCreate" (click)="toggleToCreate()">
          <ng-container *ngIf="!onlyToCreate">
            <span class="student-to-create-badge">{{ toCreateCount }}</span>
            <span>élève{{ toCreateCount > 1 ? 's' : '' }} à créer</span>
            <span class="student-to-create-action">Voir <i class="fa fa-arrow-right" aria-hidden="true"></i></span>
          </ng-container>
          <ng-container *ngIf="onlyToCreate">
            <i class="fa fa-arrow-left" aria-hidden="true"></i>
            <span>Afficher tous les élèves</span>
          </ng-container>
        </button>
      </div>
    </div>

    <div class="student-list-actions">
      <div id="search" class="student-list-search">
        <i class="fa fa-search student-list-search-icon" aria-hidden="true"></i>
        <input type="search" id="inputStudent" #studentInput
               class="form-control"
               placeholder="Rechercher un élève"
               aria-label="Rechercher un élève"
               (input)="onSearchChange($event.target)">
      </div>
      <a *ngIf="!iIsArchived && !readOnlyService.isReadOnly() && !iUseExternalDataFlow"
         routerLink="/new-student" class="btn student-list-add">
        <i class="fa fa-plus" aria-hidden="true"></i><span>Nouvel élève</span>
      </a>
    </div>
  </div>

  <div class="student-table-card">
    <table class="table student-table">
      <thead>
      <tr>
        <th scope="col">Élève</th>
        <th scope="col" class="student-col-formula">Formule</th>
        <th scope="col" class="student-col-status">Statut</th>
        <th scope="col" class="student-col-date">Inscription</th>
        <th scope="col" class="student-col-arrow"><span class="sr-only">Ouvrir</span></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let s of iStudents" (click)="consultStudent(s.id)" (keydown.enter)="consultStudent(s.id)"
          tabindex="0" [ngClass]="{'new-student': s.status === 'TO_CREATE'}">
        <td class="student-cell-identity">
          <span class="student-avatar" [ngClass]="'avatar-' + avatarColor(s)">{{ initials(s) }}</span>
          <span class="student-identity">
            <span class="student-name">{{ s.lastname | uppercase }} {{ s.firstname }}</span>
            <span class="student-contact" *ngIf="s.phoneNumber || s.email">{{ s.phoneNumber || s.email }}</span>
          </span>
        </td>
        <td class="student-col-formula" data-label="Formule">
          <span class="student-formula" *ngIf="s.formula">{{ s.formula.name }}</span>
        </td>
        <td class="student-col-status" data-label="Statut">
          <span class="student-status" [ngClass]="'status-' + (s.status || 'UNKNOWN')">{{ getStatusValue(s.status) }}</span>
        </td>
        <td class="student-col-date" data-label="Inscription">{{ s.registrationDate | date:'dd/MM/yyyy' }}</td>
        <td class="student-col-arrow"><i class="fa fa-chevron-right" aria-hidden="true"></i></td>
      </tr>
      </tbody>
    </table>

    <div class="student-empty" *ngIf="iStudents && iStudents.length === 0">
      <i class="fa fa-user-o" aria-hidden="true"></i>
      <p>{{ inputSearchName ? 'Aucun élève ne correspond à « ' + inputSearchName + ' ».' : 'Aucun élève pour le moment.' }}</p>
    </div>
  </div>

  <app-pagination *ngIf="iPageStudent" [iEmpty]="iPageStudent.empty" [iFirst]="iPageStudent.first"
                  [iLast]="iPageStudent.last" [iNumber]="iPageStudent.number" [iTotalPages]="iPageStudent.totalPages"
                  [iPageSize]="iPageStudent.size"
                  (currentPageChanged)="onChangeStudentPage($event)">
  </app-pagination>
</div>
